import React from 'react';
import {compose} from "recompose";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {ACTION_SET_SELECTED_UNIT} from "../../../reducers/constants";
import {UNIT} from "../../../constants/routes";
import {getUnitElevation, getUnitID, getUnitName} from "../../unit/utils";

/**
 * A component that encapsulates a  unit
 * item to be displayed on a {@code UnitList}
 */
const UnitListItem = (props) => {
    return (
        <div
            key={getUnitID(props.unit)}
            className="card bg-light"
            style={{marginTop: '15px', marginBottom: '15px'}}
        >
            <div className="card-header pl-2 pr-2 pt-2 pb-0">
                <h5>
                    <div className="dashboardUnitListPicture text-center">
                        {getUnitName(props.unit).substring(0, 1).toUpperCase()}
                    </div>
                    <div className="dashboardUnitListTitle">
                        <Link
                            className="text-muted"
                            to={UNIT}
                            onClick={() => {
                                props.onSetSelectedUnit(props.unit);
                                props.history.push(UNIT);
                            }}
                        >
                            {getUnitName(props.unit)}
                        </Link>
                    </div>
                </h5>
            </div>
            <div className="card-body pt-1 pb-2 pl-2 pr-2">
                <div className="card-text">
                    <div><b>Current Speed</b>: 0mph</div>
                    <div><b>Current Elevation</b>: {getUnitElevation(props.unit) ? getUnitElevation(props.unit) + " meters" : "Unknown"}</div>
                </div>
            </div>
        </div>
    );
};

/**
 * Map Redux {@param dispatch} a.k.a. actions to component props
 */
const mapDispatchToProps = (dispatch) => ({
    onSetSelectedUnit: (selectedUnit) => dispatch({type: ACTION_SET_SELECTED_UNIT, selectedUnit})
});

export default compose(
    withRouter,
    connect(null, mapDispatchToProps)
)(UnitListItem);


// WEBPACK FOOTER //
// ./src/components/dashboard/unitlist/UnitListItem.jsx